import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
import { filterBusList, resetFilter } from "../actions/main";
import { FILTERS } from "../utils/constants";
import "../App.scss";

class BusFilter extends Component {
  handleOnClick = (type, value) => {
    this.props.filterBusList({ type: type, data: value });
  };

  render() {
    const b = this.props.busListingReducer;
    // console.log(b);

    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="title">
              <span>{"Filters"}</span>
            </div>
          </Grid>
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">cancel</i>
          </Grid>
        </Grid>
      </div>
    );

    const sortby = (
      <div className="filters">
        <p>{"Sort By"}</p>
        <div>
          <Grid container justify="flex-start">
            <Grid
              item
              xs={4}
              className={
                b.filters[FILTERS.SORT].includes("SORT_DEPARTURE")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.SORT, FILTERS.SORT_DEPARTURE)
              }
            >
              <span>{"Departure"}</span>
            </Grid>
            <Grid
              item
              xs={4}
              className={
                b.filters[FILTERS.SORT].includes("SORT_DURATION")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.SORT, FILTERS.SORT_DURATION)
              }
            >
              <span>{"Duration"}</span>
            </Grid>
            <Grid
              item
              xs={4}
              className={
                b.filters[FILTERS.SORT].includes("SORT_FARE")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.SORT, FILTERS.SORT_FARE)
              }
            >
              <span>{"Fare"}</span>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    const busType = (
      <div style={{ marginBottom: "1rem" }}>
        <p>{"Bus Type"}</p>
        <div className="filters">
          <Grid container justify="flex-start">
            <Grid
              item
              xs={6}
              className={
                b.filters[FILTERS.FILTER_BUS_TYPE].includes("SLEEPER")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.FILTER_BUS_TYPE, FILTERS.SLEEPER)
              }
            >
              <span>{"Sleeper"}</span>
            </Grid>
            <Grid
              item
              xs={6}
              className={
                b.filters[FILTERS.FILTER_BUS_TYPE].includes("SEMI_SLEEPER")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(
                  FILTERS.FILTER_BUS_TYPE,
                  FILTERS.SEMI_SLEEPER
                )
              }
            >
              <span>{"Semi Sleeper"}</span>
            </Grid>
          </Grid>
          <Grid container justify="flex-start">
            <Grid
              item
              xs={6}
              className={
                b.filters[FILTERS.FILTER_BUS_TYPE].includes("AC")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.FILTER_BUS_TYPE, FILTERS.AC)
              }
            >
              <span>{"AC"}</span>
            </Grid>
            <Grid
              item
              xs={6}
              className={
                b.filters[FILTERS.FILTER_BUS_TYPE].includes("MULTI_AXLE")
                  ? "box active"
                  : "box"
              }
              onClick={() =>
                this.handleOnClick(FILTERS.FILTER_BUS_TYPE, FILTERS.MULTI_AXLE)
              }
            >
              <span>{"Multi Axle"}</span>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    const boardingdroppingPoints = (
      <div className="filters" style={{ border: "1px solid #ddd" }}>
        <div
          style={{ borderBottom: "1px solid #ddd" }}
          className={
            b.filters[FILTERS.FILTER_BOARDING].length > 0
              ? "item active"
              : "item"
          }
          onClick={() =>
            this.props.history.push(
              "/bus-booking-phonepe/select-filter/boarding"
            )
          }
        >
          <i className="material-icons">directions_bus</i>&nbsp;&nbsp;&nbsp;
          <span>Boarding Points</span>
        </div>

        <div
          className={
            b.filters[FILTERS.FILTER_DROPPING].length > 0
              ? "item active"
              : "item"
          }
          onClick={() =>
            this.props.history.push(
              "/bus-booking-phonepe/select-filter/dropping"
            )
          }
        >
          <i className="material-icons">directions_bus</i>&nbsp;&nbsp;&nbsp;
          <span>Dropping Points</span>
        </div>
      </div>
    );

    const filterbyTime = (
      <div className="filters">
        <div style={{ marginBottom: "1rem" }}>
          <p>{"Departure Time"}</p>
          <div>
            <Grid container justify="flex-start">
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_DEPART_TIME] === FILTERS.BEFORE6AM
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_DEPART_TIME,
                    FILTERS.BEFORE6AM
                  )
                }
              >
                <span>{"Before 6AM"}</span>
              </Grid>
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_DEPART_TIME] ===
                  FILTERS.BETWEEN_6AM_12PM
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_DEPART_TIME,
                    FILTERS.BETWEEN_6AM_12PM
                  )
                }
              >
                <span>{"6AM-12PM"}</span>
              </Grid>
            </Grid>

            <Grid container justify="flex-start">
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_DEPART_TIME] ===
                  FILTERS.BETWEEN_12PM_6PM
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_DEPART_TIME,
                    FILTERS.BETWEEN_12PM_6PM
                  )
                }
              >
                <span>{"12PM-6PM"}</span>
              </Grid>
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_DEPART_TIME] === FILTERS.AFTER6PM
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_DEPART_TIME,
                    FILTERS.AFTER6PM
                  )
                }
              >
                <span>{"After 6PM"}</span>
              </Grid>
            </Grid>
          </div>
        </div>

        <div style={{ marginBottom: "2rem" }}>
          <p>{"Arrival Time"}</p>
          <div>
            <Grid container justify="flex-start">
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_ARRIVAL_TIME].includes("BEFORE6AM")
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_ARRIVAL_TIME,
                    FILTERS.BEFORE6AM
                  )
                }
              >
                <span>{"Before 6AM"}</span>
              </Grid>
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_ARRIVAL_TIME].includes(
                    "BETWEEN_6AM_12PM"
                  )
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_ARRIVAL_TIME,
                    FILTERS.BETWEEN_6AM_12PM
                  )
                }
              >
                <span>{"6AM-12PM"}</span>
              </Grid>
            </Grid>
            <Grid container justify="flex-start">
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_ARRIVAL_TIME].includes(
                    "BETWEEN_12PM_6PM"
                  )
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_ARRIVAL_TIME,
                    FILTERS.BETWEEN_12PM_6PM
                  )
                }
              >
                <span>{"12PM-6PM"}</span>
              </Grid>
              <Grid
                item
                xs={6}
                className={
                  b.filters[FILTERS.FILTER_ARRIVAL_TIME].includes("AFTER6PM")
                    ? "box active"
                    : "box"
                }
                onClick={() =>
                  this.handleOnClick(
                    FILTERS.FILTER_ARRIVAL_TIME,
                    FILTERS.AFTER6PM
                  )
                }
              >
                <span>{"After 6PM"}</span>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );

    const bottommenu = (
      <div className="bottom-fixed-details">
        <div variant="contained" className="filter-button">
          <Grid container justify="flex-start">
            <Grid
              item
              xs={6}
              onClick={() => this.props.resetFilter()}
              style={{ borderRight: "1px solid white" }}
            >
              <span>{"Reset All"}</span>
            </Grid>
            <Grid item xs={6} onClick={() => this.props.history.goBack()}>
              <span>{"Apply"}</span>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    return (
      <div className="bus-booking">
        {header}
        <div style={{ padding: "2rem" }}>
          {sortby}
          {busType}
          {filterbyTime}
          {boardingdroppingPoints}
        </div>

        {bottommenu}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    busListingReducer: state.busListingReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    filterBusList: filter => {
      dispatch(filterBusList(filter));
    },
    resetFilter: reset => {
      dispatch(resetFilter(reset));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BusFilter);
